import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import Button from '../../UI/Button';
import Loading from '../../UI/Loading';
import { ADMIN, COORDENADOR, PROFESSOR } from '../../Usuario/Perfil';


const useStyles = makeStyles({
    container: {
        marginTop: '20px',
        marginBottom: '20px'
    },
    image: {
        height: '200px',
        cursor: 'pointer',
    },
    divImage: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    buttonSelect: {
        marginTop: '20px',
    }
})

const MuralFotoList = ({
    setMuralFoto,
    muralFotos,
    handleOpenFullImage
}) => {
    const classes = useStyles();
    const usuario = useSelector(state => state.usuario);


    return (
        <Grid
            className={classes.container}
            container
            direction='row'
            alignContent='flex-start'
            spacing={3}
        >
            <>
                {muralFotos.content.map((mf) => (
                    <Grid
                        key={mf.codigo}
                        size={{
                            xs: 12,
                            sm: 12,
                            md: 6,
                            lg: 4,
                            xl: 4
                        }}>
                        {
                            mf.foto ?
                                <div className={classes.divImage}>
                                    <img
                                        onClick={() => handleOpenFullImage(mf.foto)}
                                        className={classes.image}
                                        src={mf.foto}
                                        alt=''
                                    />
                                    {usuario.perfil === ADMIN ||
                                        usuario.perfil === COORDENADOR ||
                                        usuario.perfil === PROFESSOR ?
                                        <Button
                                            onClick={() => setMuralFoto(mf)}
                                            className={classes.buttonSelect}
                                        >
                                            Selecionar
                                        </Button> : ''
                                    }
                                </div>
                                :
                                <p>Nenhuma Imagem Selecionado</p>
                        }
                    </Grid>
                ))}
                <Grid
                    justifyContent='center'
                    alignContent='center'
                    alignItems='center'
                    size={{
                        xs: 12,
                        sm: 12,
                        md: 6,
                        lg: 4,
                        xl: 4
                    }}>
                    {muralFotos.number === -1 ||
                        muralFotos.number + 1 < muralFotos.totalPages ?
                        <Loading description="Carregando..." /> :
                        ''}
                </Grid>
            </>
        </Grid >
    );
}

export default MuralFotoList;